import _ from "lodash";
import { createSelector } from "reselect";
import { RootState } from "sweet-web/redux";

const s = (state: RootState) => state.auth;

export const uid = (state: RootState) => s(state).uid;

export const isAuthenticating = (state: RootState) => s(state).isAuthenticating;
